import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMail } = FiIcons;

const Footer = () => {
  return (
    <motion.footer 
      className="bg-white border-t border-gray-200 mt-12"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.2 }}
    >
      <div className="container mx-auto px-4 py-6 max-w-4xl">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <div className="text-center md:text-left">
            <p className="text-sm text-gray-600">
              © {new Date().getFullYear()} Package Promote Scale. All rights reserved.
            </p>
          </div>
          
          <div className="flex items-center space-x-2">
            <SafeIcon icon={FiMail} className="text-gray-600" />
            <a 
              href="mailto:jodie@packagepromotescale.com"
              className="text-sm text-gray-600 hover:text-blue-600 transition-colors"
            >
              jodie@packagepromotescale.com
            </a>
          </div>
        </div>
        
        <div className="mt-4 text-xs text-gray-500 text-center">
          <p>
            This tool provides general information only and does not constitute financial or legal advice.
          </p>
        </div>
      </div>
    </motion.footer>
  );
};

export default Footer;